import { render, staticRenderFns } from "./ChatbotInvitationUpdate.vue?vue&type=template&id=02d0bf2e&"
import script from "./ChatbotInvitationUpdate.vue?vue&type=script&lang=js&"
export * from "./ChatbotInvitationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports